import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpStatusCode
} from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { FIELD_DEFINITIONS_VALIDATOR, INTERPRETER_VALIDATOR, PATTERN_VALIDATOR } from '../resources/resources';
import { AnalyticsService } from '../services/analytics.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
    /**
     * @param router
     * @param errorHandler
     * Handle error in requests, if an Unauthorized error status is caught the
     * app will automatically redirect to authentication page
     */
    constructor(
        private router: Router,
        private errorHandler: ErrorHandler,
        private analyticsService: AnalyticsService,
        private snackService: SnackBarService
    ) { }

    validationEndpoints = [
        PATTERN_VALIDATOR,
        INTERPRETER_VALIDATOR,
        FIELD_DEFINITIONS_VALIDATOR
    ]

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            // we catch the error
            catchError((errorResponse: HttpErrorResponse) => {
                // log in console
                console.log({ errorResponse }); // eslint-disable-line no-console
                // log in Application Insights
                if (this.analyticsService) {
                    this.analyticsService.trackError(errorResponse);
                }

                // if the status is 401 Unauthorized
                if (errorResponse.status === HttpStatusCode.Unauthorized) {
                    // we redirect to authentication
                    this.router.navigateByUrl('/login');
                } else {
                    const errorLog = JSON.stringify(errorResponse, null, 2) + JSON.stringify(request.body, null, 2)
                    if (this.shouldNotifyError(request, errorResponse)) {
                        this.snackService.detailedError(
                            'An unexpected error occurred while processing your request.',
                            errorLog,
                            false
                        );
                    }
                    this.errorHandler.handleError(errorResponse);
                }
                return throwError(errorResponse);
            })
        );
    }

    private shouldNotifyError(request: HttpRequest<any>, errorResponse: HttpErrorResponse) {
        const errorMessage = (errorResponse?.message || '').toLowerCase();
        return !this.validationEndpoints.some(endpoint => request.url.includes(endpoint)) &&
            !errorMessage.toLowerCase().includes('unknown error');
    }
}
